import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import Tooltip from '@atlaskit/tooltip';
import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { IconButton } from '@atlaskit/button/new';
import { token } from '@atlaskit/tokens';

const messages = defineMessages({
  markAsRead: {
    id: 'app-updates-table.unread-dot.mark-as-read',
    defaultMessage: 'Mark as read',
  },
});

const styles = cssMap({
  dot: {
    width: '8px',
    height: '8px',
    borderRadius: token('radius.full'),
    backgroundColor: token('color.background.accent.blue.bolder'),
    display: 'block',
  },
});

interface UnreadDotProps {
  onClick: () => void;
  testId?: string;
}

export const UnreadDot: React.FC<UnreadDotProps> = ({ onClick, testId }) => {
  const { formatMessage } = useIntl();

  return (
    <Tooltip content={formatMessage(messages.markAsRead)} position="top">
      {(tooltipProps) => (
        <IconButton
          {...tooltipProps}
          testId={testId}
          appearance="subtle"
          icon={(props) => <Box {...props} xcss={styles.dot} />}
          spacing="compact"
          onClick={onClick}
          label={formatMessage(messages.markAsRead)}
        />
      )}
    </Tooltip>
  );
};
